export default __webpack_public_path__ + "static/media/car.4f4db78c.png";